import { useEffect, useState } from 'react';
import { listBills, type BillRecord } from '@/lib/db/billsRepo';
import BillListItem from '@/features/history/BillListItem';

export default function HistoryPage() {
  const [bills, setBills] = useState<BillRecord[] | null>(null);

  useEffect(() => {
    void listBills().then(setBills);
  }, []);

  return (
    <div className="flex flex-col gap-4 p-4 pt-6">
      <header>
        <h1 className="text-xl font-bold text-slate-900">Bill History</h1>
      </header>

      {bills === null ? (
        <p className="text-sm text-slate-400">Loading…</p>
      ) : bills.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-500">
          No bills yet — scan one from the Home tab.
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {bills.map((bill) => (
            <BillListItem key={bill.id} bill={bill} />
          ))}
        </div>
      )}
    </div>
  );
}
